import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ChannelService } from '@app/core/channels/services/channel.service';
import { RfqService } from '@app/core/quotes';

@Component({
  selector: 'cnc-retail-prices',
  templateUrl: './retail-prices.component.html',
  styleUrls: ['./retail-prices.component.scss'],
})
export class RetailPricesComponent implements OnInit, OnDestroy {
  constructor(
    private rfqSvc :RfqService,
    private channelSvc :ChannelService,
    private cd :ChangeDetectorRef,
  ) {}

  rfqs :any[] = [];
  channels :any[] = [];
  // page = 1;
  // pageSize = 20;
  filter :any = {};

  params :any = {
    per_page: 20,
    page: 1,
  };
  pageSizeOptions :number[] = [5, 10, 25, 100];

  loadingRfqs :boolean;
  channelSub :Subscription;
  rfqSub :Subscription;
  rfqRecord :any = {};

  ngOnInit() {
    this.channelSvc.get({ all: 1 });
    this.loadingRfqs = true;
    this.channelSub = this.channelSvc.channels$.subscribe((channels) => {
      if (channels && channels.length > 0) {
        this.channels = channels;
        this.channels = channels.map((channel) => {
          return { id: channel.id, label: channel.label, price: 0 };
        });
        this.getRecords();
      }
    });
  }

  ngOnDestroy() {
    this.channelSub.unsubscribe();
    this.rfqSub.unsubscribe();
  }

  getRecords(event ?:any, page ?:number) {
    this.loadingRfqs = true;

    if (page) {
      this.params.page = page;
    }
    if (event) {
      this.params.page = event.pageIndex + 1;
      this.params.per_page = event.pageSize;
    }

    this.params = Object.assign(this.params, this.filter);
    if (this.params.keyword && this.params.keyword.length == 0) {
      delete this.params.keyword;
    }

    // getRecords(page?) {
    this.rfqSub = this.rfqSvc
      .getActiveRetailPrices(this.params)
      .subscribe((rfqs) => {
        this.rfqRecord = rfqs;
        // this.rfqs = rfqs;
        this.rfqRecord.data.forEach((rfq :any) => {
          rfq.channels = JSON.parse(JSON.stringify(this.channels));
          if (rfq.active_channel_prices && rfq.active_channel_prices.length > 0) {
            rfq.active_channel_prices.forEach((ach) => {
              const channel = rfq.channels.find((row) => row.id == ach.channel_id);
              if (channel) {
                channel.price = ach.unitPrice;
              }
            });
          }
        });
        this.loadingRfqs = false;
        this.cd.detectChanges();
      });
  }
}
